import { toolboxComponents } from "@client/components/PageSkeleton/Toolbox";
import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { ArticlesGridBlock } from "../components/ArticlesGridBlock";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (props: templates.ArticleLpTemplate) => {
    return (
        <PageSkeleton {...props.page} breadcrumbs_theme="robinsBlue">
            <StreamField
                tagName={React.Fragment}
                components={{
                    ...toolboxComponents,
                    articles_grid: (args) => (
                        <ArticlesGridBlock
                            {...args}
                            articles={props.page.articles}
                        />
                    ),
                }}
                value={props.page.body.value}
            />
        </PageSkeleton>
    );
};
